import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  margin: 0 auto;
  ${({ theme }) => css`
    max-width: ${theme.breakpoints.lg};
  `}
`;
export const SinceInFoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const SinceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 2)};

    ${theme.media.md.up} {
      padding: 0;
    }
  `}
`;

export const SinceHeader = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.almostBlack};
    font-size: ${theme.fontSizes.h2};
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h1};
    }
  `}
  font-weight: bold;
  text-transform: uppercase;
`;

export const Text = styled(Box)`
  ${({ theme }) => css`
    width: 100%;
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
    line-height: 1.5;
    font-weight: 400;
    text-align: center;
    margin: ${theme.spacing(2, 7.5, 8, 7.5)};
    white-space: pre-wrap;
  `}
`;

export const HistoryWarpper = styled(Box)`
  display: flex;
  grid-template-columns: repeat(2, minmax(469px, 1fr));
  column-gap: 64px;
  flex-wrap: wrap;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      .my-masonry-grid {
        display: flex;
        justify-content: space-between;
      }
      .my-masonry-grid_column {
        width: calc(50% - 32px) !important;
      }
    }
  `}
`;
